import { render, staticRenderFns } from "./DocumentList.vue?vue&type=template&id=7f10d3f4&scoped=true"
import script from "./DocumentList.vue?vue&type=script&lang=ts"
export * from "./DocumentList.vue?vue&type=script&lang=ts"
import style0 from "./DocumentList.vue?vue&type=style&index=0&id=7f10d3f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f10d3f4",
  null
  
)

export default component.exports